import MetricGridSkeleton from "./MetricGridSkeleton";
import ObjectHeaderSkeleton from "./ObjectHeaderSkeleton";
import TableSkeleton from "./TableSkeleton";
import TabsSkeleton from "./TabsSkeleton";

export default function ObjectDetailPageSkeleton() {
  return (
    <div className="mt-8" data-testid="object-detail-page-skeleton">
      <ObjectHeaderSkeleton />
      <TabsSkeleton />
      <MetricGridSkeleton cards={3} />
      <TableSkeleton columns={4} rows={4} />
    </div>
  );
}
